import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { OnlineInventoryAPI } from "../../modules/OnlineInventory/api/onlineInventoryAPI";

const keyQuery = ["OnlineInventorys"];
const keyQueryArchived = ["OnlineInventoryArchived"];
const keyMutation = ["createOnlineInventory"];

export const useFetchOnlineInventoryProgrammed = (filters?: any) => {
  return useQuery<any, Error>({
    queryKey: [keyQuery, filters || {}],
    queryFn: ({ queryKey }) => OnlineInventoryAPI.fetchInventories({ queryKey }),
    staleTime: 0,
  });
};

export const useFetchOnlineInventory = (filters?: any) => {
   return useQuery<any, Error>({
    queryKey: [keyQuery, filters || {}],
    queryFn: ({ queryKey }) => OnlineInventoryAPI.fetchMovements({ queryKey }),
    staleTime: 0,
  });
};

export const useFetchOnlineInventoryArchived = () => {
  return useQuery({
    queryKey: keyQueryArchived,
    queryFn: OnlineInventoryAPI.fetchMovementsArchived,
    staleTime: 0,
  });
};


export const useCreateOnlineInventory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: keyMutation,
    mutationFn: OnlineInventoryAPI.createMovement,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keyQuery });
    },
    onError: (error) => {
      console.error("Error al crear el movimiento:", error);
    },
  });
};

export const useFetchOnlineInventoryDetail = (ticketId: string) => {
  const queryKey = ["OnlineInventoryDetail", ticketId];

  return useQuery({
    queryKey,
    queryFn: () => OnlineInventoryAPI.fetchMovementDetail(ticketId),
    enabled: !!ticketId,
  });
};